const stages = [
  { key: 'shape', label: 'Shape' },
  { key: 'decide', label: 'Decide' },
  { key: 'build', label: 'Build' },
  { key: 'check', label: 'Check' },
  { key: 'maintain', label: 'Maintain' },
];

const details = {
  shape: {
    input: 'Opportunity, evidence, constraints',
    authority: 'Challenge assumptions and define intent',
    output: 'Live strategy and decisions to make',
  },
  decide: {
    input: 'Options, evidence, affected commitments',
    authority: 'Compare tradeoffs and preserve human approval',
    output: 'Owned, traceable product decision',
  },
  build: {
    input: 'Approved intent, sources, standards',
    authority: 'Translate direction into executable constraints',
    output: 'Brief for people and agents',
  },
  check: {
    input: 'Artifact, implementation, review evidence',
    authority: 'Apply the agreed promotion contract',
    output: 'Promote, constrain, revise, or reject',
  },
  maintain: {
    input: 'New evidence, drift, recurring signals',
    authority: 'Connect change to affected decisions',
    output: 'Reviewed learning and current direction',
  },
};

export default function DocsWorkflowVisual({ active }) {
  const current = details[active];

  return (
    <div className="my-9 overflow-hidden rounded-2xl border border-gray-200 bg-gray-50/70 dark:border-brand-50/10 dark:bg-brand-800/20">
      <div className="border-b border-gray-200 px-5 py-5 dark:border-brand-50/10">
        <p className="mb-5 text-[10px] font-bold uppercase tracking-[0.18em] text-gray-400 dark:text-brand-600">
          Decisions and authority lifecycle
        </p>
        <div className="relative grid grid-cols-5 gap-2">
          <div className="absolute left-[10%] right-[10%] top-3 h-px bg-gray-200 dark:bg-brand-700" />
          {stages.map((stage, index) => {
            const isActive = stage.key === active;
            const activeIndex = stages.findIndex((item) => item.key === active);
            const complete = index < activeIndex;
            return (
              <div key={stage.key} className="relative z-10 flex min-w-0 flex-col items-center text-center">
                <div className={`flex h-6 w-6 items-center justify-center rounded-full border text-[10px] font-bold ${
                  isActive
                    ? 'border-gray-900 bg-gray-900 text-white shadow-[0_0_0_4px_rgba(17,24,39,0.08)] dark:border-white dark:bg-white dark:text-gray-900 dark:shadow-[0_0_0_4px_rgba(255,255,255,0.08)]'
                    : complete
                      ? 'border-emerald-500 bg-emerald-500 text-white'
                      : 'border-gray-300 bg-white text-gray-400 dark:border-brand-600 dark:bg-brand-900 dark:text-brand-600'
                }`}>
                  {complete ? '✓' : index + 1}
                </div>
                <span className={`mt-2 truncate text-[11px] font-semibold ${
                  isActive ? 'text-gray-900 dark:text-brand-50' : 'text-gray-400 dark:text-brand-600'
                }`}>
                  {stage.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1.15fr_auto_1fr] sm:items-stretch">
        <VisualCell eyebrow="Input" text={current.input} />
        <Arrow />
        <VisualCell eyebrow="Pabs authority" text={current.authority} emphasis />
        <Arrow />
        <VisualCell eyebrow="Durable output" text={current.output} />
      </div>
    </div>
  );
}

function VisualCell({ eyebrow, text, emphasis = false }) {
  return (
    <div className={`p-5 ${emphasis ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900' : ''}`}>
      <p className={`mb-2 text-[9px] font-bold uppercase tracking-[0.18em] ${
        emphasis ? 'text-gray-400' : 'text-gray-400 dark:text-brand-600'
      }`}>
        {eyebrow}
      </p>
      <p className={`m-0 text-[13px] font-medium leading-relaxed ${
        emphasis ? '' : 'text-gray-700 dark:text-brand-300'
      }`}>
        {text}
      </p>
    </div>
  );
}

function Arrow() {
  return (
    <div className="hidden items-center px-1 text-gray-300 sm:flex dark:text-brand-700" aria-hidden="true">
      →
    </div>
  );
}
